
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import WxHeader from './Header'

export default {

components: {
WxHeader,
XButton,
Alert,
AlertModule,
Group,
Cell
},
data () {
return {
tag: '',
index:0,
checkCode: '',
is_click_vscode : true,
time : 60,
phone_msg : '获取验证码',
post : {
account : '',
vcode : 'yawen',
phone_code : ''
}
}
},
created () {
let is_su = this.check_account_exists();
if(is_su){
this.auto_wx_bind();
this.createCode();
}
},
methods:{
check_account_exists(){
let login_data = this.get_login_session_data();


if(login_data.account){
this.baseShowModuleAuto('你已经绑定过手机号！','禁止重复绑定',2000);
this.$router.push({path: '/MemberCenter'});
return false;
}
return true;
},
auto_wx_bind(){
let title = '授权成功，请您绑定手机号';
let content = '微信授权成功，必须绑定手机号才能进行其他操作';
this.baseShowModuleAuto (title,content,10000)
},
check_click_vscode(){
console.log('check_click_vscode')
this.is_click_vscode =false
let dx_djs=setInterval(()=>{
if ((this.time--) <= 0) {
this.time = 60;
this.phone_msg = '重新获取';
this.is_click_vscode = true;
clearInterval(dx_djs);
}
},1000)
},
get_phone_code(){
var _self = this;
if(!this.check_phone_show_msg(this.post.account)){
return false;
}
/*if(!this.checkvscode()){
return false;
}*/
let api_url = this.server_api_url+'service=send_phone_vscode';

let formData = {};
formData = this.post;

let login_data = this.get_login_session_data();
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
}else{
return false;
}
formData = this.qs.stringify(formData);


this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,
}).then((response) =>{
console.log(response.data);
let data_arr = response.data;
_self.check_token_data_status(data_arr);
if(data_arr.status == '1' && !!  data_arr.data.phone_code_msg){
this.baseShowModule(data_arr.data.phone_code_msg);
_self.check_click_vscode();
}else{
_self.baseShowModule(data_arr.msg);
}
}).catch((response) =>{
console.log(response)
})
},
check_phone_show_msg(account){
let is_phone = this.check_is_phone(account);
if(!is_phone){
this.baseShowModuleAuto('手机号不正确！','请输入有效的手机号码',30000);
}
return is_phone;
},
submit(){
let _self = this;
if(!this.check_phone_show_msg(_self.post.account)){
return false;
}

/*
real_name : '',
house_addr : ''
if(_self.post.real_name.length < 2 || _self.post.real_name.length > 10){
this.baseShowModuleAuto('户主真名必须在2-10个字','请输入真名',30000);
return false;
}

if(_self.post.house_addr.length < 2 || _self.post.house_addr.length > 30){
this.baseShowModuleAuto('户主的房间地址必须2-30字！','如XXX栋楼XXX号',30000);
return false;
}*/

let api_url = this.server_api_url+'service=wxlogin_save_account';
var formData = _self.post;
let login_data = this.get_login_session_data();
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
}else{
return true;
}
formData = this.qs.stringify(formData);
this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,
/*data:this.qs.stringify({
code:code,
state:state
})*/

}).then((response) =>{
let data_arr = response.data;
_self.check_token_data_status(data_arr);
if(data_arr.status == '1'){


_self.set_login_session_data(data_arr.data);
_self.set_access_token(data_arr.access_token);
_self.baseShowModuleAuto(data_arr.msg,'温馨提示',1500,'/MemberCenter');


}else{
_self.baseShowModule(data_arr.msg);
_self.post.phone_code = '';
}
}).catch((response) =>{
console.log(response)
})
},
createCode(){
let code = "";
var codeLength = 4;
var random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R',
'S','T','U','V','W','X','Y','Z');
for(var i = 0; i < codeLength; i++) {
var index = Math.floor(Math.random()*36);
code += random[index];
}
this.checkCode = code;
},

checkvscode(){
let is_success = false;
this.post.vcode.toUpperCase();
if(this.post.vcode == '') {
this.baseShowModuleAuto('请输入验证码','验证码不能为空',30000);
}else if(this.post.vcode.toUpperCase() != this.checkCode ) {
this.baseShowModuleAuto('验证码输入错误','请重新输入验证码',30000);
this.createCode();
this.post.vcode = '';
}else {

this.createCode();
is_success = true;
}
return is_success;
}
}
}



// WEBPACK FOOTER //
// ./src/components/Login.vue